export default {
    base: "DEVNOT MENTOR",
  };